import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Alert } from "antd";
import axios from "axios";
import { ConsignmentStatusEnum } from "./api/Representation";
import { userHasPermission } from "../../../../swzutils/UserPermissionsUtil";
import { axiosErrorHandler } from "../../../../swzutils";
import { loggedInUserSelector } from "../../../../store/slice/auth";
import { useAppSelector } from "../../../../store";
const ConsignmentHasBeenInvoicedAlert = ({ consignmentId, consignmentStatus }) => {
    const [hasBeenInvoiced, setHasBeenInvoiced] = useState(false);
    const loggedInUser = useAppSelector(loggedInUserSelector);
    useEffect(() => {
        if (consignmentId && consignmentStatus === ConsignmentStatusEnum.COMPLETED && userHasPermission(loggedInUser, ['subtruxOperations:viewContractorRates'])) {
            setHasBeenInvoiced(false);
            axios.get(`/admin/v1/consignments/${consignmentId}/financials`).then(response => {
                setHasBeenInvoiced(response.data.hasBeenInvoiced);
            }).catch(axiosErrorHandler);
        }
    }, [consignmentId, consignmentStatus, loggedInUser]);
    if (!hasBeenInvoiced) {
        return null;
    }
    return (_jsx("div", { className: "pt-20", children: _jsx(Alert, { style: { paddingTop: 20 }, title: "Delivery has been invoiced", description: "IMPORTANT: An invoice and a contractor payment for this delivery have been created so any changes you make here must also be manually updated in Xero.", type: "warning", showIcon: true }) }));
};
export default ConsignmentHasBeenInvoicedAlert;
